class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    /*
      ┌─────────────────────────────────────────────────────────────────────────────┐
      │     TO ENABLE CITY BASED FILTERING                                          │
      └─────────────────────────────────────────────────────────────────────────────┘
    */
    this.isCityBasedFilteringEnabled = this.dataset.cityBasedSearch === undefined ? false : true;
    this.defaultCity = this.dataset.defaultCity === undefined ? 'city_doha' : this.dataset.defaultCity !== '' ? this.dataset.defaultCity : 'city_doha';
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static processMobileActiveFacets() {
    const activeFacets = document.querySelector(".active-facets.active-facets-desktop.mobile");
    const insideBlock = activeFacets?.querySelector(".inside-block");

    if (activeFacets && insideBlock) {
      // Hide city filters from mobile active facets
      const facetRemoves = insideBlock.querySelectorAll('facet-remove');
      let visibleFiltersCount = 0;
      
      // Get current URL's city filter values for comparison
      const currentUrl = new URL(window.location.href);
      const currentCityFilters = currentUrl.searchParams.getAll('filter.p.m.custom.list_of_cities');
      
      // Check if inside-block has any filters at all
      if (facetRemoves.length > 0) {
        facetRemoves.forEach(facetRemove => {
          const link = facetRemove.querySelector('a');
          if (!link) {
            visibleFiltersCount++;
            return;
          }
          
          const href = link.getAttribute('href') || '';
          const paramName = link.getAttribute('data-param-name') || '';
          
          // Check if this is a city filter removal
          let isCityFilter = false;
          
          // Method 1: Check data-param-name attribute (most reliable)
          if (paramName === 'filter.p.m.custom.list_of_cities') {
            isCityFilter = true;
          }
          // Method 2: Compare city filter values between current URL and link URL
          else if (href && currentCityFilters.length > 0) {
            try {
              const linkUrl = new URL(href, window.location.origin);
              const linkCityFilters = linkUrl.searchParams.getAll('filter.p.m.custom.list_of_cities');
              
              // If link has fewer city filter values, it's removing a city filter
              if (linkCityFilters.length < currentCityFilters.length) {
                isCityFilter = true;
              }
              // If link URL has no city filter but current has one, and no other filters are being removed
              else if (linkCityFilters.length === 0 && currentCityFilters.length > 0) {
                const currentFilterParams = Array.from(currentUrl.searchParams.keys()).filter(key => key.startsWith('filter.'));
                const linkFilterParams = Array.from(linkUrl.searchParams.keys()).filter(key => key.startsWith('filter.'));
                // If only city filter is being removed (no other filters in link)
                if (currentFilterParams.length === 1 && linkFilterParams.length === 0) {
                  isCityFilter = true;
                }
              }
            } catch (e) {
              // If URL parsing fails, don't treat as city filter
            }
          }
          
          if (isCityFilter) {
            facetRemove.style.display = 'none';
          } else {
            facetRemove.style.display = '';
            visibleFiltersCount++;
          }
        });
      }

      // Hide/show "Clear all" button based on visible filters
      const clearAllButton = activeFacets.querySelector('.active-facets__button-wrapper');
      const filterClearWrapper = activeFacets.querySelector('.filter-clear-wrapper');
      if (clearAllButton) {
        if (visibleFiltersCount > 0) {
          clearAllButton.style.display = '';
          if (filterClearWrapper) filterClearWrapper.style.display = '';
        } else {
          clearAllButton.style.display = 'none';
          if (filterClearWrapper) filterClearWrapper.style.display = 'none';
        }
      }

      // Show container if there are any visible (non-city) filters
      if (visibleFiltersCount > 0) {
        activeFacets.style.display = "block";
      } else {
        activeFacets.style.display = "none";
      }
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        if (typeof appendBannersInsideProductGrid === 'function') appendBannersInsideProductGrid();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    if (typeof appendBannersInsideProductGrid === 'function') appendBannersInsideProductGrid();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    // Ensure prices are updated after AJAX loads
    if (typeof initialCurrencyChange === 'function') {
      initialCurrencyChange();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    if (!count) return;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    // Process mobile active facets
    FacetFiltersForm.processMobileActiveFacets();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    // Process mobile active facets after rendering
    FacetFiltersForm.processMobileActiveFacets();

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    let searchParams = new URLSearchParams(formData).toString();
    /*
      ┌─────────────────────────────────────────────────────────────────────────────┐
      │     City Based Filter Added                                                 │
      └─────────────────────────────────────────────────────────────────────────────┘
    */
    if (this.isCityBasedFilteringEnabled) {
      let city = localStorage.getItem('city') ? localStorage.getItem('city') : `${this.defaultCity}`;
      if (!searchParams.includes('filter.p.tag') && !searchParams.includes('sort_by')) {
        searchParams += `&filter.p.tag=${city}`;
      }
    }
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (this.dataset.filterType === 'vertical') {
          if (window.innerWidth >= 750 && (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm')) {
            forms.push(this.createSearchParams(form));
          } else if (window.innerWidth < 750 && (form.id === 'FacetSortForm' || form.id === 'FacetFiltersFormMobile')) {
            forms.push(this.createSearchParams(form));
          }
        } else if (this.dataset.filterType === 'horizontal') {
          if (window.innerWidth >= 750 && form.id === 'FacetFiltersForm') {
            forms.push(this.createSearchParams(form));
          } else if (window.innerWidth < 750) {
            let searchparam = this.createSearchParams(form);
            if(searchparam.includes('&sort_by=')) {
              forms.push(`&sort_by=${searchparam.split('&sort_by=')[1]}`);
            } else {
              forms.push(this.createSearchParams(form));
            }
          }
        } else {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    let city = localStorage.getItem('city') ? localStorage.getItem('city') : `${this.defaultCity}`;
    let defaultFilter = this.isCityBasedFilteringEnabled ? `filter.p.tag=${city}` : '';

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? `${defaultFilter}`
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
    this.observer = null;
    this.isLoading = false;
  }

  connectedCallback() {
    this.addEventListener('click', this.onClickHandler);
    if (this.getAttribute('type') === 'infinite') {
      this.createObserver();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  createObserver() {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      console.warn('IntersectionObserver not supported, falling back to click-based loading');
      return;
    }
    const options = {
      root: null,
      rootMargin: '200px 0px 200px 0px',
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading) {
          this.onClick();
        }
      });
    }, options);
    this.observer.observe(this);
  }

  onClick() {
    if (this.isLoading || this.classList.contains('btn--loading')) return;
    this.isLoading = true;
    this.loadingState();

    const url = this.setUrl().toString();

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        this.renderPagination(responseText);
        this.renderProductGridContainer(responseText);
        if (this.observer) {
          this.observer.disconnect();
          this.createObserver();
        }
      })
      .catch((error) => {
        console.error('Error loading more products:', error);
        // Reset loading state on error
        this.isLoading = false;
        this.classList.remove('btn--loading');
        this.classList.remove('pointer-events-none');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  renderPagination(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const pagination = productGridContainer.querySelector('.pagination');
    const source = parsedHTML.querySelector('.pagination');

    if (source) {
      pagination.innerHTML = source.innerHTML;
    } else {
      pagination.remove();
    }
  }

  renderProductGridContainer(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const productList = productGridContainer.querySelector('#product-grid');
    const source = parsedHTML.querySelector('#product-grid');

    if (source && productList) {
      const fragment = document.createDocumentFragment();
      source.querySelectorAll('li.grid__item').forEach((item) => {
        fragment.appendChild(item.cloneNode(true));
      });
      productList.appendChild(fragment);
    }

    // Use requestAnimationFrame for smoother animations
    requestAnimationFrame(() => {
      if (typeof productCardSwiper === 'function') productCardSwiper();
      if (typeof initialCurrencyChange === 'function') initialCurrencyChange();
      if (typeof appendBannersInsideProductGrid === 'function') appendBannersInsideProductGrid();
    });
  }

  setUrl() {
    const url = new URL(this.getAttribute('action'));
    url.searchParams.set('section_id', this.getSectionId(this));
    return url;
  }

  getSectionId(element) {
    if (element.hasAttribute('data-section-id')) {
      return element.dataset.sectionId;
    } else {
      if (!element.classList.contains('shopify-section')) {
        element = element.closest('.shopify-section');
      }
      return element.id.replace('shopify-section-', '');
    }
  }

  loadingState() {
    this.classList.add('pointer-events-none');
    this.classList.add('btn--loading');

    // Use requestAnimationFrame for smoother state changes
    requestAnimationFrame(() => {
      const collectionGrid = document.querySelectorAll('#product-grid li');
      const collectionId = document.querySelector('#product-grid')?.getAttribute('collection-id');
      const collectionTitle = document.querySelector('#product-grid')?.getAttribute('collection-title');

      if (collectionGrid && collectionId && collectionTitle) {
        window.viewProductList(collectionGrid, collectionTitle, collectionId);
      }
    });
  }
}

// Add a check to ensure the custom element is not already defined
if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}

// Adds active class to element when user stops scrolling
// And Removes class when user starts scrolling
function toggleActiveClassWhileScrolling(elementSelector, classToAdd = 'active', delay = 300) {
  const element = document.querySelector(elementSelector);

  if (!element) {
    console.error(`Element with selector "${elementSelector}" not found`);
    return;
  }

  let scrollTimeout;
  function addActiveClass() {
    element.classList.add(`${classToAdd}`);
  }
  // Add event listener for scroll events
  window.addEventListener('scroll', function () {
    // Remove the active class while scrolling
    element.classList.remove(`${classToAdd}`);

    // Clear any existing timeout
    clearTimeout(scrollTimeout);

    // Set a new timeout to add the class back after scrolling stops
    // Adjust the delay (300ms) to your preference - this determines how long
    // after scrolling stops before the class is added back
    scrollTimeout = setTimeout(addActiveClass, delay);
  });

  // Ensure the element has the active class initially
  addActiveClass();
}

// toggleActiveClassWhileScrolling('.mobile-facets__open-wrapper', 'active', 700);

function submitSortForm(value) {
  let form = document.querySelector('#FacetSortDrawerForm') ? document.querySelector('#FacetSortDrawerForm') : document.querySelector('#FacetSortForm') ? document.querySelector('#FacetSortForm') : document.querySelector('#FacetFiltersForm');
  let select = form.querySelector('select');
  select.value = value;
  form.dispatchEvent(new Event('input'));
}

function openSortModal(event) {
  event.stopPropagation();
  event.preventDefault();

  let sortModalContent = document.querySelector('#mobile-filter-modal-content');

  let sortModal = new Modal('sortMobileModal', {
    content: sortModalContent,
    onConfirm: (e) => {
      let value = e.currentTarget.getAttribute('value');
      let allOptions = sortModalContent.querySelectorAll('.mobile-facets__options');

      allOptions.forEach((option) => {
        option.classList.remove('selected');
      });

      [...allOptions].find((option) => option.getAttribute('value') === value).classList.add('selected');

      submitSortForm(value);
    }
  })
}

let mobileSortButton = document.getElementById('SortMobileButton');

if (mobileSortButton) {
  mobileSortButton.addEventListener('click', openSortModal);
}

window.addEventListener('DOMContentLoaded', () => {
  let collectionQuickFilterWrappers = document.querySelectorAll('.collection_quick_filters-wrapper');

  if(Array.isArray(collectionQuickFilterWrappers) && collectionQuickFilterWrappers.length <= 0) return;

  collectionQuickFilterWrappers.forEach((wrapper) => {
    wrapper.addEventListener('mousewheel', function(e) {
      this.scrollLeft -= (e.wheelDelta);
      e.preventDefault();
    }, false);
  });
}, { once: true });


document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile view
  function isMobile() {
    return window.innerWidth <= 989;
  }
  const filterButtons = document.querySelector('.mobile-filter-buttons-container');
  const collapsableSection = document.querySelector('#index-collapsable-custom') || document.querySelector('.index-collapsable-custom');
  const footer = document.querySelector('footer');

  function isElementInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
  }

  function handleScroll() {
    if (!isMobile() || !filterButtons) {
      if (filterButtons) filterButtons.style.display = '';
      return;
    }
    const atCollapsable = isElementInViewport(collapsableSection);
    const atFooter = isElementInViewport(footer);
    if (atCollapsable || atFooter) {
      filterButtons.style.display = 'none';
    } else {
      filterButtons.style.display = '';
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll);
  handleScroll();
});

/**
 * City Filter Synchronization
 * Automatically sync city selection from header with facet filters
 */
function syncCityFilterWithHeader() {
  const currentCity = localStorage.getItem('city_value') || localStorage.getItem('city');
  if (!currentCity) return;
  
  
  // Find city filter checkboxes
  const cityFilterCheckboxes = document.querySelectorAll('input[name="filter.p.m.custom.list_of_cities"]');
  
  cityFilterCheckboxes.forEach(checkbox => {
    const checkboxValue = checkbox.value;
    
    // Use global city matcher if available
    let isMatch = false;
    if (window.CityMatcher) {
      isMatch = window.CityMatcher.match(checkboxValue, currentCity);
    } else {
      // Fallback to local normalization logic
      const normalizedCheckbox = normalizeCityForComparison(checkboxValue);
      const normalizedCurrent = normalizeCityForComparison(currentCity);
      isMatch = normalizedCheckbox === normalizedCurrent;
    }
    
    if (isMatch && !checkbox.checked) {
      
      // Check the checkbox
      checkbox.checked = true;
      
      // Add active class to label
      const label = checkbox.closest('label');
      if (label) {
        label.classList.add('active');
      }
      
      // Trigger the facet update without causing a page reload
      const facetForm = checkbox.closest('form');
      if (facetForm) {
        // Create a synthetic input event to trigger facet filtering
        setTimeout(() => {
          const inputEvent = new Event('input', { bubbles: true });
          facetForm.dispatchEvent(inputEvent);
        }, 100);
      }
    } else if (!isMatch && checkbox.checked) {
      // Uncheck if it doesn't match current city
      checkbox.checked = false;
      const label = checkbox.closest('label');
      if (label) {
        label.classList.remove('active');
      }
    }
  });
}

/**
 * Normalize city name for comparison
 */
function normalizeCityForComparison(cityName) {
  if (!cityName) return '';
  
  let normalized = cityName.toLowerCase().trim();
  
  // Remove common prefixes/suffixes
  normalized = normalized.replace(/^(city of|deliver to|يسلم إلى:?)\s*/i, '');
  normalized = normalized.replace(/\s+(city|مدينة)$/i, '');
  
  // Normalize hyphens and spaces for consistent matching - remove all hyphens and normalize spaces
  normalized = normalized.replace(/[-\s]+/g, ' ').trim();
  
  // Handle common abbreviations
  normalized = normalized.replace(/\balk\b/g, 'al ');
  normalized = normalized.replace(/\bkh\b/g, 'khobar');
  
  // Handle common city variations
  const cityMappings = {
    'riyadh': 'riyadh',
    'الرياض': 'riyadh',
    'al khobar': 'al khobar',
    'alkhobar': 'al khobar',
    'khobar': 'al khobar',
    'الخبر': 'al khobar',
    'dammam': 'dammam',
    'الدمام': 'dammam',
    'dhahran': 'dhahran',
    'الظهران': 'dhahran',
    'jubail': 'jubail',
    'الجبيل': 'jubail',
    'jeddah': 'jeddah',
    'جدة': 'jeddah',
    'القطيف': 'qatif',
    'المدينة':'madinah',
    'مكه':'Meccah'

  };
  
  return cityMappings[normalized] || normalized;
}

// Listen for city changes from header
document.addEventListener('city-changed', function(event) {
  const newCity = event.detail.textValue || event.detail.city || event.detail.value;
  if (newCity) {
    setTimeout(() => {
      syncCityFilterWithHeader();
    }, 200);
  }
});

// Sync on page load
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    syncCityFilterWithHeader();
  }, 2000);
  
  // Process mobile active facets on page load
  FacetFiltersForm.processMobileActiveFacets();
  
  // Also run after delays to catch any late-rendered elements
  setTimeout(() => {
    FacetFiltersForm.processMobileActiveFacets();
  }, 500);
  
  setTimeout(() => {
    FacetFiltersForm.processMobileActiveFacets();
  }, 1500);
});

// Make sync function globally available
window.syncCityFilterWithHeader = syncCityFilterWithHeader;

